export default "__VITE_ASSET__49ea02da__"